import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../../modules/infra/i18n';

import mailchimpIcon from '../../../../../../../images/mailchimpIcon.png';
import Icon, { GLYPHS } from '../../../../../common/icon';
import DisconnectMailchimp from './DisconnectMailchimpModal';

const MailchimpSettingsPage = ({ emailAddress }) => (
  <div className="mailchimp-settings">
    <img
      alt="mailchimp-logo"
      className="mailchimp-logo"
      src={mailchimpIcon}
      role="presentation"
    />
    <h1>{t('settings:integrations.mailchimp.settings.heading')}</h1>
    <h2>{t('settings:integrations.mailchimp.settings.subheading')}</h2>
    <div className="mailchimp-settings__body">
      <div className="mailchimp-settings__card">
        <strong>{t('settings:integrations.mailchimp.settings.status_label')}</strong>
        <div>
          <Icon glyph={GLYPHS.checkMarkBlue} className="o-icon--micro" />
          <span>{t('settings:integrations.mailchimp.settings.connected_to')} <strong>{emailAddress}</strong></span>
        </div>
      </div>
    </div>
    <div className="mailchimp-settings__footer">
      <DisconnectMailchimp />
    </div>
  </div>
);

MailchimpSettingsPage.propTypes = {
  emailAddress: PropTypes.string.isRequired,
};

export default MailchimpSettingsPage;
